import React from 'react'
import ServicesHeader from '../services/servicesHeader'
import { Box, Divider, Typography } from '@mui/material'
import background from '../_content/paving4.webp'
import Gallery from '../components/beforeAfterGallery'

const PortfolioPage = () => {
  return (
    <>
      <ServicesHeader background={background} text="Portfolio & Transformations" />

      <Divider orientation='vertical' flexItem sx={{ color: 'white', border: '1px solid' }} />
        <Box sx={{ backgroundColor: '#8FAA30', mx: 'auto', padding: 3}}>
          <Typography  sx={{color: 'white', textAlign: 'center', fontSize: '1.25rem' }}>
            Below you can see examples of our expertly crafted work and transformations, showcasing the quality and care we put into every project, and how we can transform YOUR outdoor space.
          </Typography>
        </Box>
      <Divider orientation='vertical' flexItem sx={{ color: 'white', border: '1px solid' }} />

      <Box
        width={{ xs: 0.95, md: 0.8 }}
        height={{ xs: 'auto', md: '500px' }}
        sx={{ mx: 'auto', mt: 4, mb: 16 }}
      >
        <Gallery height='500px' showTitle />
      </Box>
    </>
  )
}

export default PortfolioPage